"use client";

// X3 · "Our fault, not yours" (Claude Design · States & Messages). When
// Explore can't load: say whose fault it is and that nothing was lost, show
// a reference to quote, and one amber "Try again".

import { useMemo } from "react";
import { CircleAlert } from "lucide-react";
import { Button } from "@/components/kit/Button";
import { FactTable } from "@/components/kit/FactTable";

const TIME = new Intl.DateTimeFormat("en-GB", { hour: "2-digit", minute: "2-digit" });

export default function ExploreError({ error, reset }: { error: Error & { digest?: string }; reset: () => void }) {
  const at = useMemo(() => TIME.format(new Date()), []);
  return (
    <div className="mx-auto flex min-h-[70dvh] w-full max-w-[560px] flex-col px-6 pt-[calc(4rem+env(safe-area-inset-top))] pb-8 md:justify-center md:pt-16">
      <p className="flex items-center gap-2 text-ink">
        <CircleAlert size={16} strokeWidth={2.2} className="shrink-0" aria-hidden />
        <span className="mf-label text-ink">Our fault, not yours</span>
      </p>
      <h1 className="mf-h1 mt-3 text-ink">That didn’t load.</h1>
      <p className="mf-body mt-3 max-w-[320px] text-faint">
        Nothing you did caused this, and nothing was lost. Try again in a moment.
      </p>
      <FactTable
        className="mt-6"
        rows={[
          ...(error.digest ? [{ label: "Reference", value: error.digest.slice(0, 10).toUpperCase(), mono: true }] : []),
          { label: "Time", value: at, mono: true },
        ]}
      />
      <div className="min-h-8 flex-1 md:min-h-12 md:flex-none" />
      <Button size="lg" block onClick={reset}>
        Try again
      </Button>
    </div>
  );
}
